import React from 'react';
import EndGameStatsModal from './EndGameStatsModal';

import {
  BaseModalBackground,
  ModalBackground,
  Header,
  Body,
  StyledModal,
} from './modal';
import { StyledExtraModal } from './MessageModal';

export default () => {
  return <ModalBackground zIndex={1}>
    <BaseModalBackground>
      <StyledModal>
        <Header>
          Transmissão recebida do controle de solo
        </Header>
        <Body>
          <p>Oh não! Sua nave esgotou os recursos necessários para mantê-la em movimento para que vocês possam cumprir sua missão!</p>
          <p>Envie uma chamada de socorro para o comandante espacial e enviaremos mais instruções.</p>
          <p>-Controle de solo</p>
        </Body>
      </StyledModal>
      <StyledExtraModal>
        <EndGameStatsModal />
      </StyledExtraModal>    
    </BaseModalBackground>
  </ModalBackground>
}